// const cartIcons = document.querySelectorAll('.shakeCart');
// const root = document.documentElement;

// function triggerAnimation() {
//   // Set on root only once
//   root.style.setProperty('--shake-animation', 'shakeCart 0.5s ease');

//   // Force animation restart by toggling class
//   cartIcons.forEach(icon => {
//     icon.classList.remove('shakeCart');
//     void icon.offsetWidth; // force reflow to restart animation
//     icon.classList.add('shakeCart');
//   });

//   // Reset after animation completes to allow re-triggering
//   setTimeout(() => {
//     root.style.setProperty('--shake-animation', 'none');
//   }, 600);
// }

// setInterval(triggerAnimation, 3000);
// triggerAnimation(); // run immediately

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".shaddow_btn_custom").forEach(button => {
        button.addEventListener("click", function () {
            // Remove border
            this.style.setProperty('box-shadow', '-1px 1px 0 black', 'important');
           this.style.setProperty('transform', 'translateY(1.5px)', 'important');

            // Reset border after 1 second
            setTimeout(() => {
                this.style.removeProperty('box-shadow');
                this.style.removeProperty('transform');
            }, 300); // 1000ms = 1 second
        });
    });
});

// Universal mega menu height set 0 when hide on scroll enabled 

 document.addEventListener('DOMContentLoaded', () => {
    const root = document.documentElement;
    const universalMenu = document.querySelector('.universal-mega-menu-section');

    function isVisible(el) {
      if (!el) return false;
      const style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetHeight > 0;
    }

    function updateUniversalMegaMenuHeight() {
      if (!universalMenu) return;

      const isDesktop = window.innerWidth >= 1070;
      const menuVisible = isVisible(universalMenu);
      const isHiddenByScroll = universalMenu.classList.contains('sticky-hide');

      if (!isDesktop || !menuVisible) {
        // fallback for mobile: reset to 0
        root.style.setProperty('--universal-mega-menu-section', '0px');
        return;
      }

      if (isHiddenByScroll) {
        root.style.setProperty('--universal-mega-menu-section', '0px');
      } else {
        root.style.setProperty('--universal-mega-menu-section', `${universalMenu.offsetHeight}px`);
      }
    }

    // Initial check
    updateUniversalMegaMenuHeight();

    // Update on scroll and resize
    window.addEventListener('scroll', updateUniversalMegaMenuHeight);
    window.addEventListener('resize', updateUniversalMegaMenuHeight);
  });